<form [formGroup]="userDetailForm" (ngSubmit)="onSubmit()" class="xr-details">
  <h2 id="profile-data-title" class="xr-card-title">{{ "personal_details.personal_details" | translate }}</h2>

  <div class="xr-details-grid">
    <div class="xr-field">
      <label class="xr-field-label" for="name">{{ "personal_details.name" | translate }}</label>
      <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
        <input matInput formControlName="name" id="name" autocomplete="given-name"/>
        <mat-error *ngIf="userDetailForm.get('name')?.hasError('required') && userDetailForm.get('name')?.touched">
          {{ "personal_details.name_required" | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="xr-field">
      <label class="xr-field-label" for="lastname">{{ "personal_details.lastname" | translate }}</label>
      <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
        <input matInput formControlName="lastname" id="lastname" autocomplete="family-name"/>
        <mat-error *ngIf="userDetailForm.get('lastname')?.hasError('required') && userDetailForm.get('lastname')?.touched">
          {{ "personal_details.lastname_required" | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="xr-field">
      <label class="xr-field-label" for="username">{{ "personal_details.username" | translate }}</label>
      <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
        <input matInput formControlName="username" id="username" autocomplete="username"/>
        <mat-error *ngIf="userDetailForm.get('username')?.hasError('required') && userDetailForm.get('username')?.touched">
          {{ "personal_details.username_required" | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="xr-field">
      <label class="xr-field-label" for="email">{{ "personal_details.email" | translate }}</label>
      <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic" class="xr-readonly">
        <input readonly matInput formControlName="email" id="email"/>
      </mat-form-field>
    </div>

    <div class="xr-phone">
      <div class="xr-field">
        <span class="xr-field-label" id="prefix-label">{{ "personal_details.prefix" | translate }}</span>
        <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
          <mat-select formControlName="prefix" id="prefix" aria-labelledby="prefix-label"
                      (openedChange)="onPrefixDropdownOpened($event)">
            <mat-option>
              <input matInput #filterInput [placeholder]="'personal_details.search' | translate" [attr.aria-label]="'personal_details.search' | translate" [(ngModel)]="prefixFilter"
                [ngModelOptions]="{ standalone: true }" (click)="$event.stopPropagation()"/>
            </mat-option>
            <mat-option *ngFor="let prefix of filteredPrefixes()" [value]="prefix.id">
              {{ prefix.prefix }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="xr-field">
        <label class="xr-field-label" for="phone">{{ "personal_details.phone" | translate }}</label>
        <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
          <input type="tel" matInput formControlName="phone" id="phone" autocomplete="tel-national" (input)="onPhoneInput($event)"/>
          <mat-error *ngIf="userDetailForm.controls['phone'].hasError('invalidPhone')">
            {{ "personal_details.phone_validator" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  @if (user?.roles || user?.company) {
    <p class="xr-details-meta">
      @if (user?.roles; as role) {
        <span>{{ "personal_details.role" | translate }}: <strong>{{ role.name }}</strong></span>
      }
      @if (user?.roles && user?.company) {
        <span aria-hidden="true">·</span>
      }
      @if (user?.company; as company) {
        <span>{{ "personal_details.company" | translate }}: <strong>{{ company.name }}</strong></span>
      }
    </p>
  }

  <div class="xr-details-actions">
    <button type="button" class="xr-btn xr-btn--secondary" (click)="resetForm()">
      {{ "personal_details.reset" | translate }}
    </button>
    <button type="submit" class="xr-btn xr-btn--primary" [disabled]="!userDetailForm.valid">
      {{ "personal_details.save_changes" | translate }}
    </button>
  </div>
</form>
